module.exports = __webpack_public_path__ + "img/currency.fw.dd81f9f9.png";